




























































import {Component, Mixins, Prop, Vue} from "vue-property-decorator";
import { logout } from "@/services/auth-service";
import { IAuthData } from "@/model/IAuthData";
import UserInfo from "@/components/UserInfo.vue";
import { IHeaderInfo } from "water-rest/src/model/sharedStore/IHeaderInfo";
import SecurityMixin from "water-rest/src/mixins/SecurityMixin.vue";
import { toggleHtmlTheme } from "@/services/theme-service";
import NotificationHandler from '@/components/notifications/NotificationHandler.vue';

@Component({
  components: {
    NotificationHandler,
    UserInfo,
  },
})
export default class HeaderActions extends Mixins(Vue, SecurityMixin) {
  @Prop({ default: 0 }) private unreadMessagesCount!: number;
  @Prop() isNotifyPanelShow!: boolean;

  logout() {
    logout();
  }

  toggleTheme() {
    toggleHtmlTheme();
  }

  get headerInfo(): IHeaderInfo {
    return this.$store.getters.getHeaderInfo;
  }

  get authData(): IAuthData {
    return this.$store.getters.authData;
  }

  toggleNotifications() {
    this.$emit('toggleNotifications');
  }
}
